import { useHistory, useLocation } from 'react-router-dom';
import { AccountStatusFilter } from 'src/utils/accountStatusFilter';

export const useAccountStatusFilter = (enabled = true) => {
    const location = useLocation();
    const history = useHistory();
    const raw = new URLSearchParams(location.search).get('status');
    const statusFilter: AccountStatusFilter =
        enabled && (raw === 'active' || raw === 'invited') ? raw : 'all';

    const setStatusFilter = (value: AccountStatusFilter) => {
        if (!enabled) return;
        const params = new URLSearchParams(location.search);
        if (value === 'all') {
            params.delete('status');
        } else {
            params.set('status', value);
        }
        const query = params.toString();
        const search = query ? `?${query}` : '';
        if (search === location.search) return;
        history.push({ ...location, search });
    };

    return { statusFilter, setStatusFilter };
};
